/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
/* eslint-disable camelcase */
/* eslint-disable react/no-string-refs */
/* eslint-disable react/no-array-index-key */


import React, { Component } from 'react';
import { Card, CardDeck, CardBody, Col, Button, ButtonToolbar, ButtonGroup, ListGroup, ListGroupItem, Table, Input } from 'reactstrap';
import 'react-table/react-table.css';
import axios from 'axios';
import { connect } from 'react-redux';
import ActionButton from './ActionButton';


const currencyFormat = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
const URL = 'https://marketplace-api.musicmarquee.co.uk';
const REQUEST_TIMEOUT_MS = 600000;


class ToolsUpdateOrders extends Component {
  constructor() {
    super();
    this.state = {
      updateOrdersResponse: { complete: false, response: undefined },
      newOrderResponse: { complete: false, response: undefined },
    };
  }

  getAxiosConfig() {
    return {
      headers: { Authorization: localStorage.getItem('mm_admin') },
      timeout: REQUEST_TIMEOUT_MS,
    };
  }

  getErrorMessage(error) {
    if (!error) return 'Unknown error.';

    if (error.code === 'ECONNABORTED') {
      return 'The request timed out before the server returned a response.';
    }

    if (error.response && error.response.data) {
      const responseData = error.response.data;

      if (typeof responseData === 'string') return responseData;
      if (responseData.error) {
        return typeof responseData.error === 'string'
          ? responseData.error
          : JSON.stringify(responseData.error);
      }
      if (responseData.message) return responseData.message;
      return JSON.stringify(responseData);
    }

    return error.message || 'Unknown error.';
  }

  async getNewShopifyOrders() {
    return this.runShopifyAction({
      responseKey: 'newOrderResponse',
      actionText: 'Getting new Shopify orders',
      task: async () => {
        const response = await axios.post(`${URL}/admin/shopify/orders`, { store: 'tints-direct' }, this.getAxiosConfig());
        this.setState({
          newOrderResponse: { complete: true, response: `Inserted ${response.data.length} New Orders.` },
        });
      },
    });
  }

  async updateShopifyOrders() {
    return this.runShopifyAction({
      responseKey: 'updateOrdersResponse',
      actionText: 'Updating Shopify orders',
      task: async () => {
        const response = await axios.post(`${URL}/admin/shopify/orders/update`, { store: 'tints-direct' }, this.getAxiosConfig());
        this.setState({
          updateOrdersResponse: { complete: true, response: response.data },
        });
      },
    });
  }

  async runShopifyAction({ responseKey, actionText, task }) {
    this.setState({
      [responseKey]: { complete: false, response: `${actionText}...` },
    });

    try {
      await task();
    } catch (error) {
      this.setState({
        [responseKey]: { complete: false, response: this.getErrorMessage(error) },
      });
    }

    return true;
  }

  render() {
    return (
      <Col style={{ height: '100%' }}>
        <Card style={{ width: '100%' }}>
          <CardBody>
            <Table striped bordered hover size="sm">
              <thead>
                <tr>
                  <th>Action</th>
                  <th>Complete</th>
                  <th>Result</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ width: '20%' }}>
                    <ActionButton
                      color="primary"
                      size="sm"
                      title="Update Shopify Orders"
                      task={() => this.updateShopifyOrders()}
                    />
                  </td>
                  <td style={{ width: '10%' }}>{this.state.updateOrdersResponse.complete ? 'Complete' : 'Not Complete'}</td>
                  <td style={{ width: '70%' }}>{this.state.updateOrdersResponse.response || ''}</td>
                </tr>
                <tr>
                  <td>
                    <ActionButton
                      color="primary"
                      size="sm"
                      title="Get New Shopify Orders"
                      task={() => this.getNewShopifyOrders()}
                    />
                  </td>
                  <td>{this.state.newOrderResponse.complete ? 'Complete' : 'Not Complete'}</td>
                  <td>{this.state.newOrderResponse.response || ''}</td>
                </tr>
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
});

// export default connect()(SidebarContent);
export default connect(mapStateToProps)(ToolsUpdateOrders);
